module.exports = __webpack_public_path__ + "assets/img/schools-page-dial.f80ff5f4.png";